import { Component, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ds-dashboard-card',
  templateUrl: './ds-dashboard-card.component.html',
  standalone: true,
  imports: [CommonModule, NgbPopoverModule, TranslateModule]
})
export class DsDashboardCardComponent {
  @Input() id: string = '';
  @Input() iconSrc: string = '';
  @Input() iconClass: string = '';
  @Input() buttonLabel: string = '';
  @Input() buttonClass: string = '';
  @Input() anchorIconSrc: string = '';
  @Input() anchorClass: string = '';
  @Input() cardTitle: string = '';
  @Input() isButtonLabel: boolean = true;
  @Input() activeItems1: number | string = 0;
  @Input() activeItems2: number | string = 0;

  // Popover configuration
  @Input() showPopover: boolean = false;
  @Input() popoverContent: TemplateRef<any> | string;
  @Input() popoverTriggers: string = 'mouseenter:mouseleave';
  @Input() popoverPlacement: 'top' | 'right' | 'bottom' | 'left' | 'auto' = 'right';
  @Input() isAnchorDisabled: boolean = false;
  @Input() isCardType: string = '--border-warning';

  @Output() buttonClick = new EventEmitter<void>();
  @Output() anchorClick = new EventEmitter<void>();

  onButtonClick() {
    this.buttonClick.emit();
  }

  onAnchorClick(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.anchorClick.emit();
  }
}
